
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/collectibles-marketplace",
      function () {
        return require("private-next-pages/[locale]/collectibles-marketplace/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/collectibles-marketplace"])
      });
    }
  